import { useEffect, useState } from "react";
import PlaceholderSvg from "../../../assets/images/placeholder-images/placeholder_250x250.svg";

interface ImageProps {
    title?: string;
    src: string;
    altText?: string;
    style?: React.CSSProperties;
    className?: string;
    loading?: string;
    width?: string;
    height?: string;
    deliveryOptions?: Partial<DeliverAPIOptions>;
}

export interface DeliverAPIOptions {
    original: boolean;
    assetId: string;
    seoFileName: string;
    crop: Crop;
    height: string;
    width: string;
    quality: string;
    format: string;
}

export interface Crop {
    cropType: string;
    cropValues: string;
}
// Todo: Consider adding lazy loading or interaction with Intersection API for even better UX.
export default function SteelcaseImage({title, width, height, src, altText, style, className, deliveryOptions}: ImageProps) {

    const [source, setSource] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const processImage = (src: string) : string => {
        let transformedUrl = src;

        if(deliveryOptions) {
            
            transformedUrl = applyOptions(transformedUrl, deliveryOptions);
            
        }

        return transformedUrl;
    }

    const generateLowResolutionUrl = (baseDeliveryUrl: string) => {
        return applyOptions(baseDeliveryUrl, {...deliveryOptions, format: "webp", width: "100", height: "100", quality: "10"})
    }

    const applyOptions = (transformedUrl: string, deliveryOptions: Partial<DeliverAPIOptions>): string => {
        if(deliveryOptions.seoFileName && deliveryOptions.original) {
            return `${transformedUrl}/original/as/${sanitizeSeoFileName(deliveryOptions.seoFileName)}${Math.random()}`
        }
        if(deliveryOptions.seoFileName && deliveryOptions.format) {
            transformedUrl += `/as/${sanitizeSeoFileName(deliveryOptions.seoFileName)}${Math.random()}.${deliveryOptions.format}`
        }

        transformedUrl = transformedUrl += "?";

        if(deliveryOptions.width) transformedUrl += `width=${deliveryOptions.width}&`;

        if(deliveryOptions.height) transformedUrl += `height=${deliveryOptions.height}&`;
        
        if(deliveryOptions.quality) transformedUrl += `quality=${deliveryOptions.quality}&`;
        

        if(deliveryOptions.crop && deliveryOptions.crop.cropType === "percentage" && deliveryOptions.crop.cropValues) transformedUrl += `crop=${deliveryOptions.crop.cropValues}&`;
        
    
        if(deliveryOptions.crop && deliveryOptions.crop.cropType === "absolute" && deliveryOptions.crop.cropValues) transformedUrl += `crop=${deliveryOptions.crop.cropValues}&`;

        if(transformedUrl.endsWith('&')) {
            transformedUrl = transformedUrl.slice(0, -1);
        }
    
        if(transformedUrl.endsWith('?')) {
            transformedUrl = transformedUrl.slice(0, -1);
        }
    
        return transformedUrl;
    }

    const sanitizeSeoFileName = (seoFileName: string) => {
        const newName = seoFileName.replaceAll("/", ".");
        return newName;
    }

    useEffect(() => {
        if(src === null || src === undefined || src === "") {
            setSource(PlaceholderSvg);
        }

        if(src && src !== null && src !== undefined && src.includes("delivery")) {
            const proccessedUrl = processImage(src)
            const lowResImage = generateLowResolutionUrl(src);

            setSource(lowResImage);

            const img: HTMLImageElement = new Image();
            img.src = proccessedUrl;
            img.onload = () => {
                setSource(proccessedUrl);
                setIsLoading(false);
            }
            
        } else {
            setSource(src);
        }
    }, [src])

    return (
        <img title={title} style={{...style, filter: isLoading && src && src.includes("delivery") ? 'blur(5px)': 'none', transition: 'filter 0.2s'}} src={source} alt={altText} className={className} width={width} height={height} />
    )
}